import { render, staticRenderFns } from "./RegisterInVirtul.vue?vue&type=template&id=5e849752&"
import script from "./RegisterInVirtul.vue?vue&type=script&lang=js&"
export * from "./RegisterInVirtul.vue?vue&type=script&lang=js&"
import style0 from "./RegisterInVirtul.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports